const architecturePage = {
  diagramTitle: "Диаграмма архитектуры",
  toolStackTitle: "Стек инструментов",
  layerUI: "Интерфейс",
  layerDB: "База данных",
  layerSOT: "Операционный SOT",
  layerKnowledge: "Информационный SOT",
  layerAutomation: "Автоматизация",
  layerMessaging: "Сообщения",
  colTool: "Инструмент",
  colLayer: "Слой",
  colRole: "Роль",
  colDoesNot: "НЕ делает",
  readOnly: "Только чтение",
  dataFromClaudeMd: "На основе CLAUDE.md",
} as const;
export default architecturePage;
